var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4636",
    "data-name": "Raggruppa 4636",
    transform: "translate(-25 -274)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2115",
    "data-name": "Rettangolo 2115",
    width: 24,
    height: 24,
    transform: "translate(25 274)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4635",
    "data-name": "Raggruppa 4635",
    transform: "translate(-52.443 -421.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sign-out-alt",
    "data-name": "Icon awesome-sign-out-alt",
    d: "M19.723,12.793,13.056,19.46a.954.954,0,0,1-1.627-.675v-3.81h-5.4a.95.95,0,0,1-.952-.952v-3.81a.95.95,0,0,1,.952-.952h5.4V5.452a.955.955,0,0,1,1.627-.675l6.667,6.667A.961.961,0,0,1,19.723,12.793Zm-12.1,6.469V17.675a.478.478,0,0,0-.476-.476H3.81a1.269,1.269,0,0,1-1.27-1.27V8.309a1.269,1.269,0,0,1,1.27-1.27H7.143a.478.478,0,0,0,.476-.476V4.976A.478.478,0,0,0,7.143,4.5H3.81A3.811,3.811,0,0,0,0,8.309v7.619a3.811,3.811,0,0,0,3.81,3.81H7.143A.478.478,0,0,0,7.619,19.262Z",
    transform: "translate(79.443 694.881)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6f6be629321ba1f33441d47bc2bc9e3d.svg";
export { ForwardRef as ReactComponent };